import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "@/app/store";

/**
 * Comandi che lo shell riceve dall'esterno. `saveRequestId` cresce a ogni evento legacy `save-changes`
 * (ConfigItem dopo l'import CSV, LayoutDesignGeneral): la barra di salvataggio lo osserva e salva.
 */
export interface ShellState {
  saveRequestId: number;
}

const initialState: ShellState = { saveRequestId: 0 };

export const shellSlice = createSlice({
  name: "shell",
  initialState,
  reducers: {
    saveRequested(state) {
      state.saveRequestId += 1;
    },
  },
});

export const { saveRequested } = shellSlice.actions;
export const selectSaveRequestId = (state: RootState): number => state.shell.saveRequestId;
